export enum StatusType {
    info = 'Informational',
    warning = 'Degraded',
    error = 'Disrupted',
    noissue = 'Resolved',
}


